module.exports = __webpack_public_path__ + "static/media/brego3596.e521f63e.jpg";